/*
 * Copyright (C) 2020 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

export interface DBaseStateSetLike {
	local: string[];
}
